import apiFn from 'common/services/api-service';

const api = () => apiFn('/api/cms/v1');

export const listTrials = async (params = {}) => {
  const { search = '', limit, page = '0', sort = '-created_at', ...otherParams } = params;

  const query = {
    limit: parseInt(limit.toString(), 10),
    offset: parseInt(page, 10) * parseInt(limit.toString(), 10),
    sort,
    ...otherParams,
  };

  // Add search parameter if provided
  if (search && search.trim()) {
    query.search = search.trim();
  }

  return api()
    .get('/event-trials', { params: query })
    .then(response => response.data);
};

export const createTrial = async payload =>
  api()
    .post('/event-trials', payload)
    .then(response => response.data);

export const extendTrial = async payload =>
  api()
    .post('/extend-event-trials', payload)
    .then(response => response.data);

export const upgradeTrial = async payload =>
  api()
    .post('/upgrade-event-trials', payload)
    .then(response => response.data);
